import { SORTORDER } from '../../utils/constants'
const ONGOINGUPCOMING = 'ongoingupcoming'
const HISTORY = 'history'
const ENROLLED = 'Enrolled'
const UNENROLLED = 'Unenrolled'
const ON_GRID = 'ON_GRID'
const OFF_GRID = 'OFF_GRID'
const APPLICATION_SUBMITTED = 'Application_Submitted'
const APPLICATION_WITHDRAWN = 'Application_Withdrawn'
const APPLICATION_APPROVED = 'Application_Approved'
const APPLICATION_REJECTED = 'Application_Rejected'
const FOR_UNENROLLMENT = 'FOR_UNENROLLMENT'

const EVENT_TYPE = {
  BATTERY_DISCHARGE: 'Discharge Event',
  BATTERY_CHARGE: 'Charge Event',
  IDLE: 'Idle Event'
}

const EVENT_SUBTYPE = {
  Charge_From_PV: 'Charge from PV',
  Charge_From_NetPV: 'Charge from Net PV',
  Charge_From_PV_Grid: 'Charge from PV and Grid',
  Discharge_To_Load: 'Discharge to Load',
  Discharge_To_Load_Grid: 'Discharge to Load and Grid',
  Discharge_To_NetLoad: 'Discharge to Net Load',
  Idle: 'Idle'
}

const defaultSubType = {
  BATTERY_DISCHARGE: 'Discharge to Load and Grid',
  BATTERY_CHARGE: 'Charge From PV and Grid',
  IDLE: 'Idle'
}

const getTableHeadings = (type, classes) => ([
  {
    id: 'eventName',
    header: 'EVENT NAME',
    isActive: true,
    isLink: true,
    className: `${classes.eventName}`
  },
  {
    id: 'eventType',
    header: 'EVENT TYPE'
  },
  {
    id: 'eventSubType',
    header: 'EVENT SUBTYPE'
  },
  {
    id: 'start_time',
    header: 'EVENT START TIME',
    isSortable: true,
    sortOrder: SORTORDER.ASC,
  },
  {
    id: 'end_time',
    header: 'EVENT END TIME',
    isSortable: true,
    sortOrder: type === HISTORY ? SORTORDER.DESC : SORTORDER.ASC,
  },
  {
    id: 'eventDuration',
    header: 'EVENT DURATION',
  },
  {
    id: 'scheduledPower',
    header: 'SCHEDULED POWER (kW)',
    className: classes.center
  },
  {
    id: 'actualPower',
    header: 'ACTUAL POWER (kW)',
    className: classes.center
  },
  {
    id: 'scheduledEnergy',
    header: 'SCHEDULED ENERGY (kWh)',
    className: classes.center
  },
  {
    id: 'actualEnergy',
    header: 'ACTUAL ENERGY (kWh)',
    className: classes.center
  },
  {
    id: 'status',
    header: 'OPT-IN-STATUS'
  }
])

const MOMENT_JS_FORMAT = {
  DATE_US: 'MM/DD/YYYY',
  DATE_US_DASH_SEPARATOR: 'MM-DD-YYYY',
  DATE_IND: 'DD/MM/YYYY',
  DATE_SHORT_MONTH__FULL_YEAR: 'DD MMM YYYY',
  TIME_12H: 'hh:mm',
  TIME_12H_AM_PM: 'hh:mm a',
  TIME_24H: 'HH:mm',
  DATE_SHORT_MONTH__FULL_YEAR_WITH_SEPARATOR: 'DD MMM, YYYY',
  SHORT_MONTH_DATE_FULL_YEAR: 'MMM DD YYYY',
  SHORT_MONTH_DATE_FULL_YEAR_WITH_SEPARATOR: 'MMM DD, YYYY',
  FULL_MONTH_DATE_FULL_YEAR_WITH_SEPARATOR: 'MMMM DD, YYYY',
}

const ENERGY_GRAPH = {
  OPACITY: {
    MIN: 0,
    MID: 0.5,
    M0x7: 0.7,
    MAX: 1,
    SERIES_HOVER: 0.5,
  },
  COLOR: {
    PRODUCTION: '#2768F6',
    PRODUCTION_PREVIOUS: '#008cab',
    PRODUCTION_LAST_YEAR: '#6c7073',
    CONSUMPTION: '#F09035',
    CONSUMPTION_PREVIOUS: '#a6490b',
    CONSUMPTION_LAST_YEAR: '#6c7073',
    IMPORTED: '#CD4425',
    EXPORTED: '#CD4425',
    IMPORTED_EXPORTED: '#CD4425',
    BATTERY_STATUS: '#3A845D',
    BATTERY_CHARGED: '#3A845D',
    BATTERY_DISCHARGED: '#3A845D',
    EMPTY_DONUT_CHART: '#d1d1d1',
    PREVIOUS: '#6c7073',
    PREVIOUS_STROKE: '#5a5a5a',
    LAST_YEAR: '#6c7073',
    LAST_YEAR_STROKE: '#6c7073',
    GENERATOR_DAY: '#9062AC',
    GENERATOR_NIGHT: '#dca2ff'
  },
}

const ENERGY_TYPE = {
  PRODUCTION: {
    SNO: 1,
    KEY: 'production',
    ICON: 'energySolar',
    STAT_TEXT: 'production',
  },
  CONSUMPTION: {
    SNO: 2,
    KEY: 'consumption',
    ICON: 'energyConsumption',
    STAT_TEXT: 'consumption',
  },
  IMPORTED: {
    SNO: 3,
    KEY: 'imported',
    ICON: 'energyGrid',
    STAT_TEXT: 'import',
  },
  EXPORTED: {
    SNO: 4,
    KEY: 'exported',
    ICON: 'energyGrid',
    STAT_TEXT: 'export',
  },
  BATTERY_CHARGED: {
    SNO: 5,
    KEY: 'battery_charged',
    ICON: 'energyBattery',
    STAT_TEXT: 'charge',
  },
  BATTERY_DISCHARGED: {
    SNO: 6,
    KEY: 'battery_discharged',
    ICON: 'energyBattery',
    STAT_TEXT: 'discharge',
  },
  BATTERY_STATUS: {
    SNO: 7,
    KEY: 'battery_status',
    STAT_TEXT: 'battery_status',
  },
  YESTERDAY: {
    SNO: 8,
    KEY: 'yesterday',
    STAT_TEXT: 'hours',
  },
  LAST_YEAR: {
    SNO: 9,
    KEY: 'last_year',
    STAT_TEXT: 'months',
  },

  BULBS: {
    SNO: 10,
    KEY: 'bulbs',
    ICON: 'energyBulb',
    STAT_TEXT: 'bulbs',
  },
  TREES: {
    SNO: 11,
    KEY: 'trees',
    ICON: 'energyTree',
    STAT_TEXT: 'saved',
  },
  CO2_EMISSION: {
    SNO: 12,
    KEY: 'CO2_emission',
    ICON: 'energyCO2',
    STAT_TEXT: 'emission_saved',
  },
  REFRIGERATOR: {
    SNO: 13,
    KEY: 'refrigerator',
    ICON: 'energyRefrigerator',
    STAT_TEXT: 'refrigerator',
  },
  NET_ENERGY: {
    SNO: 14,
    KEY: 'net_energy',
    ICON: 'energyNetExportedCircle',
    STAT_TEXT: 'netExported',
  },
  GENERATOR: {
    SNO: 15,
    KEY: 'generator',
    ICON: 'generator',
    STAT_TEXT: 'generator',
  },
}

const TYPE = {
  PRODUCTION: 'production',
  CONSUMPTION: 'consumption',
  IMPORT_EXPORT: 'import / export',
  BATTERY: 'battery'
}

const CUSTOM_TYPE = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  LIFETIME: 'decade'
}

const UNITS = {
  "Wh": {
    "single": "watt-hour",
    "plural": "watt-hours",
    "annotated_abv": "(Wh)",
    "abv": "Wh",
    "definition": "Energy production and usage is measured in watt-hours (Wh). A kilowatt-hour (kWh) is equal to 1,000 watt-hours, and is the unit commonly used by electric utilities on monthly bills."
  },
  "kWh": {
    "single": "kilowatt-hour",
    "plural": "kilowatt-hours",
    "annotated_abv": "(kWh)",
    "abv": "kWh"
  },
  "MWh": {
    "single": "megawatt-hour",
    "plural": "megawatt-hours",
    "annotated_abv": "(MWh)",
    "abv": "MWh"
  },
  "GWh": {
    "single": "gigawatt-hour",
    "plural": "gigawatt-hours",
    "annotated_abv": "(GWh)",
    "abv": "GWh"
  },
  "TWh": {
    "single": "terawatt-hour",
    "plural": "terawatt-hours",
    "annotated_abv": "(TWh)",
    "abv": "TWh"
  },
  "PWh": {
    "single": "petawatt-hour",
    "plural": "petawatt-hours",
    "annotated_abv": "(PWh)",
    "abv": "PWh"
  },
  "EWh": {
    "single": "exawatt-hour",
    "plural": "exawatt-hours",
    "annotated_abv": "(EWh)",
    "abv": "EWh"
  },
  "ZWh": {
    "single": "zettawatt-hour",
    "plural": "zettawatt-hours",
    "annotated_abv": "(ZWh)",
    "abv": "ZWh"
  },
  "YWh": {
    "single": "yottawatt-hour",
    "plural": "yottawatt-hours",
    "annotated_abv": "(YWh)",
    "abv": "YWh"
  },
  "W": {
    "single": "watt",
    "plural": "watts",
    "annotated_abv": "(W)",
    "abv": "W"
  },
  "kW": {
    "single": "kilowatt",
    "plural": "kilowatts",
    "annotated_abv": "(kW)",
    "abv": "kW"
  },
  "MW": {
    "single": "megawatt",
    "plural": "megawatts",
    "annotated_abv": "(MW)",
    "abv": "MW"
  },
  "GW": {
    "single": "gigawatt",
    "plural": "gigawatts",
    "annotated_abv": "(GW)",
    "abv": "GW"
  },
  "TW": {
    "single": "terawatt",
    "plural": "terawatts",
    "annotated_abv": "(TW)",
    "abv": "TW"
  },
  "PW": {
    "single": "petawatt",
    "plural": "petawatts",
    "annotated_abv": "(PW)",
    "abv": "PW"
  },
  "EW": {
    "single": "exawatt",
    "plural": "exawatts",
    "annotated_abv": "(EW)",
    "abv": "EW"
  },
  "ZW": {
    "single": "zettawatt",
    "plural": "zettawatts",
    "annotated_abv": "(ZW)",
    "abv": "ZW"
  },
  "YW": {
    "single": "yottawatt",
    "plural": "yottawatts",
    "annotated_abv": "(YW)",
    "abv": "YW"
  },
  "percent": {
    "single": "percent",
    "plural": "percent",
    "annotated_abv": "%",
    "abv": "%"
  },
  "minutes": {
    "zero": "minutes",
    "ltone": "minute",
    "single": "minute",
    "plural": "minutes"
  },
  "hours": {
    "zero": "hours",
    "ltone": "hour",
    "single": "hour",
    "plural": "hours"
  },
  "months": {
    "zero": "months",
    "ltone": "month",
    "single": "month",
    "plural": "months"
  },
  "years": {
    "zero": "years",
    "ltone": "year",
    "single": "year",
    "plural": "years"
  },
  "days": {
    "zero": "days",
    "ltone": "day",
    "single": "day",
    "plural": "days"
  },
  "nights": {
    "zero": "nights",
    "ltone": "night",
    "single": "night",
    "plural": "nights"
  },
  "batteries": {
    "zero": "batteries",
    "ltone": "battery",
    "single": "battery",
    "plural": "batteries"
  },
  "trees": {
    "zero": "trees",
    "ltone": "tree",
    "single": "tree",
    "plural": "trees"
  },
  "kg": {
    "zero": "kg",
    "ltone": "kg",
    "single": "kg",
    "plural": "kgs"
  },
  "laps": {
    "zero": "laps",
    "ltone": "lap",
    "single": "lap",
    "plural": "laps"
  },
  "barrels": {
    "zero": "barrels",
    "ltone": "barrel",
    "single": "barrel",
    "plural": "barrels"
  },
  "flights": {
    "zero": "flights",
    "ltone": "flight",
    "single": "flight",
    "plural": "flights"
  },
  "launches": {
    "zero": "launches",
    "ltone": "launch",
    "single": "launch",
    "plural": "launches"
  }
}

export {
  ONGOINGUPCOMING,
  HISTORY,
  ENROLLED,
  UNENROLLED,
  EVENT_TYPE,
  EVENT_SUBTYPE,
  ENERGY_TYPE,
  ENERGY_GRAPH,
  MOMENT_JS_FORMAT,
  TYPE,
  CUSTOM_TYPE,
  UNITS,
  ON_GRID,
  OFF_GRID,
  APPLICATION_SUBMITTED,
  APPLICATION_WITHDRAWN,
  APPLICATION_APPROVED,
  APPLICATION_REJECTED,
  FOR_UNENROLLMENT,
  getTableHeadings,
  defaultSubType
}



